export const exercisesMapObjectArr = [
  {
    id: "45-degree-hyperextension",
    fitNotesId: "",
  },
  {
    id: "45-degree-side-bend",
    fitNotesId: "",
  },
  {
    id: "L-pull-up",
    fitNotesId: "",
  },
  {
    id: "L-sit",
    fitNotesId: "",
  },
  {
    id: "TRX-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "TRX-body-saw",
    fitNotesId: "",
  },
  {
    id: "TRX-chest-dips",
    fitNotesId: "",
  },
  {
    id: "TRX-chest-fly",
    fitNotesId: "",
  },
  {
    id: "TRX-hip-abduction",
    fitNotesId: "",
  },
  {
    id: "TRX-hip-bridge",
    fitNotesId: "",
  },
  {
    id: "TRX-inverted-row",
    fitNotesId: "",
  },
  {
    id: "TRX-mountain-climber",
    fitNotesId: "",
  },
  {
    id: "TRX-pull-up",
    fitNotesId: "",
  },
  {
    id: "TRX-self-assisted-pull-up",
    fitNotesId: "",
  },
  {
    id: "TRX-single-leg-deadlift",
    fitNotesId: "",
  },
  {
    id: "TRX-single-leg-squat",
    fitNotesId: "",
  },
  {
    id: "TRX-triceps-dips",
    fitNotesId: "",
  },
  {
    id: "TRX-twisting-jack-knife",
    fitNotesId: "",
  },
  {
    id: "TRX-wide-grip-inverted-row-on-floor",
    fitNotesId: "",
  },
  {
    id: "ab-bench-crunch",
    fitNotesId: "",
  },
  {
    id: "ab-roller-crunch",
    fitNotesId: "",
  },
  {
    id: "ab-wheel-rollout",
    fitNotesId: "Ab-Wheel Rollout",
  },
  {
    id: "above-head-chest-stretch",
    fitNotesId: "",
  },
  {
    id: "air-bike-crunch",
    fitNotesId: "",
  },
  {
    id: "all-fours-squad-stretch",
    fitNotesId: "",
  },
  {
    id: "alternate-dumbbell-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "alternate-heel-touch-side-kick-squat",
    fitNotesId: "",
  },
  {
    id: "alternate-heel-touchers",
    fitNotesId: "",
  },
  {
    id: "alternate-leg-raise",
    fitNotesId: "",
  },
  {
    id: "alternate-lying-floor-leg-raise",
    fitNotesId: "",
  },
  {
    id: "alternate-oblique-crunch",
    fitNotesId: "",
  },
  {
    id: "alternating-front-dumbbell-raise",
    fitNotesId: "",
  },
  {
    id: "alternating-kettlebell-floor-press",
    fitNotesId: "",
  },
  {
    id: "alternating-kettlebell-renegade-row",
    fitNotesId: "",
  },
  {
    id: "alternating-punches",
    fitNotesId: "",
  },
  {
    id: "alternating-step-out",
    fitNotesId: "",
  },
  {
    id: "alternating-superman",
    fitNotesId: "",
  },
  {
    id: "archer-pull-up",
    fitNotesId: "",
  },
  {
    id: "archer-push-up",
    fitNotesId: "",
  },
  {
    id: "arm-bike-machine",
    fitNotesId: "",
  },
  {
    id: "arm-circles",
    fitNotesId: "",
  },
  {
    id: "arms-vertical-stretch-extension",
    fitNotesId: "",
  },
  {
    id: "around-the-world-superman-hold",
    fitNotesId: "",
  },
  {
    id: "assault-bike",
    fitNotesId: "",
  },
  {
    id: "assault-run",
    fitNotesId: "",
  },
  {
    id: "assisted-chin-up",
    fitNotesId: "",
  },
  {
    id: "assisted-close-grip-underhand-chin-up",
    fitNotesId: "",
  },
  {
    id: "assisted-pull-up",
    fitNotesId: "",
  },
  {
    id: "assisted-single-leg-press",
    fitNotesId: "",
  },
  {
    id: "assisted-sit-up-with-chair",
    fitNotesId: "",
  },
  {
    id: "assisted-sit-up",
    fitNotesId: "",
  },
  {
    id: "assisted-triceps-dips",
    fitNotesId: "",
  },
  {
    id: "assisted-weighted-push-up",
    fitNotesId: "",
  },
  {
    id: "back-extension-on-stability-ball",
    fitNotesId: "",
  },
  {
    id: "back-lever",
    fitNotesId: "",
  },
  {
    id: "back-slaps-wrap-around-stretch",
    fitNotesId: "",
  },
  {
    id: "backward-abdominal-stretch",
    fitNotesId: "",
  },
  {
    id: "ball-rolling-pectorial-release",
    fitNotesId: "",
  },
  {
    id: "band-45-degrees-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "band-assisted-chin-up",
    fitNotesId: "",
  },
  {
    id: "band-assisted-dips",
    fitNotesId: "",
  },
  {
    id: "band-assisted-pull-up",
    fitNotesId: "",
  },
  {
    id: "band-bench-press",
    fitNotesId: "",
  },
  {
    id: "band-bent-over-hip-extension",
    fitNotesId: "",
  },
  {
    id: "band-bent-over-lat-pulldown",
    fitNotesId: "",
  },
  {
    id: "band-bent-over-rear-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "band-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "band-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "band-bulgarian-split-squat",
    fitNotesId: "",
  },
  {
    id: "band-calf-raise",
    fitNotesId: "",
  },
  {
    id: "band-chest-fly",
    fitNotesId: "",
  },
  {
    id: "band-chest-press",
    fitNotesId: "",
  },
  {
    id: "band-deadlift",
    fitNotesId: "",
  },
  {
    id: "band-decline-sit-up",
    fitNotesId: "",
  },
  {
    id: "band-good-morning",
    fitNotesId: "",
  },
  {
    id: "band-high-row",
    fitNotesId: "",
  },
  {
    id: "band-hip-abduction",
    fitNotesId: "",
  },
  {
    id: "band-hip-thrust",
    fitNotesId: "",
  },
  {
    id: "band-horizontal-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "band-horizontal-pallof-press",
    fitNotesId: "",
  },
  {
    id: "band-kneeling-hip-thrust",
    fitNotesId: "",
  },
  {
    id: "band-kneeling-lat-pulldown",
    fitNotesId: "",
  },
  {
    id: "band-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "band-low-chest-press",
    fitNotesId: "",
  },
  {
    id: "band-overhead-side-band",
    fitNotesId: "",
  },
  {
    id: "band-overhead-single-arm-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "band-overhead-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "band-pallof-press",
    fitNotesId: "",
  },
  {
    id: "band-peroneals-stretch",
    fitNotesId: "",
  },
  {
    id: "band-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "band-pull-aparat",
    fitNotesId: "",
  },
  {
    id: "band-pull-through",
    fitNotesId: "",
  },
  {
    id: "band-push-up",
    fitNotesId: "",
  },
  {
    id: "band-pushdown",
    fitNotesId: "",
  },
  {
    id: "band-rear-delt-fly",
    fitNotesId: "",
  },
  {
    id: "band-reverse-crunch",
    fitNotesId: "",
  },
  {
    id: "band-reverse-fly",
    fitNotesId: "",
  },
  {
    id: "band-reverse-wrist-curl",
    fitNotesId: "",
  },
  {
    id: "band-seated-hip-abduction",
    fitNotesId: "",
  },
  {
    id: "band-seated-hip-external-rotation",
    fitNotesId: "",
  },
  {
    id: "band-seated-hip-internal-rotation",
    fitNotesId: "",
  },
  {
    id: "band-seated-leg-extension",
    fitNotesId: "",
  },
  {
    id: "band-seated-row",
    fitNotesId: "",
  },
  {
    id: "band-shoulder-stretch-behind-the-back",
    fitNotesId: "",
  },
  {
    id: "band-shrug",
    fitNotesId: "",
  },
  {
    id: "band-side-bend",
    fitNotesId: "",
  },
  {
    id: "band-single-arm-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "band-split-squat",
    fitNotesId: "",
  },
  {
    id: "band-squat-twist",
    fitNotesId: "",
  },
  {
    id: "band-standing-crunch",
    fitNotesId: "",
  },
  {
    id: "band-standing-hammer-curl",
    fitNotesId: "",
  },
  {
    id: "band-standing-hamstring-curl",
    fitNotesId: "",
  },
  {
    id: "band-standing-hip-extension",
    fitNotesId: "",
  },
  {
    id: "band-standing-rear-delt-row",
    fitNotesId: "",
  },
  {
    id: "band-triceps-kickback",
    fitNotesId: "",
  },
  {
    id: "band-triceps-pushdown",
    fitNotesId: "",
  },
  {
    id: "band-twist",
    fitNotesId: "",
  },
  {
    id: "band-upper-body-dead-bug",
    fitNotesId: "",
  },
  {
    id: "band-warm-up-shoulder-stretch",
    fitNotesId: "",
  },
  {
    id: "band-wrist-curl",
    fitNotesId: "",
  },
  {
    id: "band-y-raise",
    fitNotesId: "",
  },
  {
    id: "barbell-incline-skull-crusher",
    fitNotesId: "",
  },
  {
    id: "barbell-box-squat",
    fitNotesId: "Barbell Box Squat",
  },
  {
    id: "barbell-bent-over-row",
    fitNotesId: "Barbell Row",
  },
  {
    id: "barbell-biceps-curl",
    fitNotesId: "Barbell Curl",
  },
  {
    id: "barbell-bulgarian-split-squat",
    fitNotesId: "",
  },
  {
    id: "close-grip-barbell-bench-pin-press",
    fitNotesId: "Close Grip Bench Pin Press",
  },
  {
    id: "close-grip-barbell-bench-press",
    fitNotesId: "Close Grip Barbell Bench Press",
  },
  {
    id: "barbell-close-grip-overhead-press",
    fitNotesId: "",
  },
  {
    id: "barbell-deadlift",
    fitNotesId: "Deadlift",
  },
  {
    id: "barbell-drag-curl",
    fitNotesId: "",
  },
  {
    id: "barbell-floor-press",
    fitNotesId: "Barbell Floor Press",
  },
  {
    id: "barbell-front-box-squat",
    fitNotesId: "",
  },
  {
    id: "barbell-front-raise",
    fitNotesId: "",
  },
  {
    id: "barbell-front-squat",
    fitNotesId: "Barbell Front Squat",
  },
  {
    id: "barbell-glute-bridge",
    fitNotesId: "Barbell Glute Bridge",
  },
  {
    id: "barbell-guillotine-bench-press",
    fitNotesId: "",
  },
  {
    id: "barbell-hack-squat",
    fitNotesId: "",
  },
  {
    id: "barbell-high-pull",
    fitNotesId: "High Pull",
  },
  {
    id: "barbell-hip-thrust",
    fitNotesId: "",
  },
  {
    id: "barbell-jm-bench-press",
    fitNotesId: "",
  },
  {
    id: "barbell-lunge",
    fitNotesId: "",
  },
  {
    id: "barbell-lying-rear-delt-row",
    fitNotesId: "",
  },
  {
    id: "barbell-lying-triceps-extension",
    fitNotesId: "Lying Triceps Extension",
  },
  {
    id: "barbell-overhead-press",
    fitNotesId: "Overhead Press",
  },
  {
    id: "barbell-overhead-shrug",
    fitNotesId: "",
  },
  {
    id: "barbell-overhead-squat",
    fitNotesId: "",
  },
  {
    id: "barbell-power-jerk",
    fitNotesId: "",
  },
  {
    id: "barbell-power-snatch-from-blocks",
    fitNotesId: "",
  },
  {
    id: "barbell-power-snatch",
    fitNotesId: "",
  },
  {
    id: "barbell-preacher-curl",
    fitNotesId: "Barbell Preacher Curl",
  },
  {
    id: "barbell-prone-incline-curl",
    fitNotesId: "",
  },
  {
    id: "barbell-pull-over-to-press",
    fitNotesId: "",
  },
  {
    id: "barbell-pullover",
    fitNotesId: "",
  },
  {
    id: "barbell-rack-pull",
    fitNotesId: "Rack Pull",
  },
  {
    id: "barbell-rear-delt-raise",
    fitNotesId: "",
  },
  {
    id: "barbell-rear-delt-row",
    fitNotesId: "",
  },
  {
    id: "barbell-reverse-close-grip-bench-press",
    fitNotesId: "",
  },
  {
    id: "barbell-reverse-lunge",
    fitNotesId: "",
  },
  {
    id: "barbell-reverse-wrist-curl",
    fitNotesId: "",
  },
  {
    id: "barbell-rollout",
    fitNotesId: "",
  },
  {
    id: "barbell-romanian-deadlift",
    fitNotesId: "",
  },
  {
    id: "barbell-seal-row",
    fitNotesId: "",
  },
  {
    id: "barbell-seated-calf-raise",
    fitNotesId: "",
  },
  {
    id: "barbell-seated-overhead-press",
    fitNotesId: "",
  },
  {
    id: "barbell-seated-overhead-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "barbell-shrug",
    fitNotesId: "Barbell Shrug",
  },
  {
    id: "barbell-side-bend",
    fitNotesId: "",
  },
  {
    id: "barbell-side-split-squat",
    fitNotesId: "",
  },
  {
    id: "barbell-single-leg-deadlift",
    fitNotesId: "",
  },
  {
    id: "barbell-skull-crusher",
    fitNotesId: "",
  },
  {
    id: "barbell-split-jerk",
    fitNotesId: "",
  },
  {
    id: "barbell-split-squat",
    fitNotesId: "",
  },
  {
    id: "barbell-squat",
    fitNotesId: "Barbell Squat",
  },
  {
    id: "barbell-standing-calf-raise",
    fitNotesId: "Barbell Calf Raise",
  },
  {
    id: "barbell-step-up",
    fitNotesId: "",
  },
  {
    id: "barbell-stiff-leg-deadlift",
    fitNotesId: "Stiff-Legged Deadlift",
  },
  {
    id: "barbell-sumo-deadlift",
    fitNotesId: "Sumo Deadlift",
  },
  {
    id: "barbell-sumo-romanian-deadlift",
    fitNotesId: "",
  },
  {
    id: "barbell-sumo-squat",
    fitNotesId: "",
  },
  {
    id: "barbell-thruster",
    fitNotesId: "",
  },
  {
    id: "barbell-upright-row",
    fitNotesId: "",
  },
  {
    id: "barbell-wide-grip-upright-row",
    fitNotesId: "",
  },
  {
    id: "barbell-wrist-curl",
    fitNotesId: "",
  },
  {
    id: "battle-ropes",
    fitNotesId: "",
  },
  {
    id: "bear-crawl",
    fitNotesId: "",
  },
  {
    id: "behind-the-back-barbell-wrist-curl",
    fitNotesId: "",
  },
  {
    id: "bench-adductors-side-plank",
    fitNotesId: "",
  },
  {
    id: "bench-dips",
    fitNotesId: "",
  },
  {
    id: "bench-flutter-kicks",
    fitNotesId: "",
  },
  {
    id: "bench-oblique-crunch",
    fitNotesId: "",
  },
  {
    id: "bench-pull-up",
    fitNotesId: "",
  },
  {
    id: "bent-arm-EZ-bar-pullover",
    fitNotesId: "",
  },
  {
    id: "bent-arm-wall-stretch",
    fitNotesId: "",
  },
  {
    id: "bent-knee-glute-kickback",
    fitNotesId: "",
  },
  {
    id: "bent-knee-lying-twist",
    fitNotesId: "",
  },
  {
    id: "bent-leg-barbell-inverted-row",
    fitNotesId: "",
  },
  {
    id: "bent-over-cable-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "bent-over-vbar-row",
    fitNotesId: "",
  },
  {
    id: "dumbbell-biceps-curl",
    fitNotesId: "Dumbbell Curl",
  },
  {
    id: "bird-dog",
    fitNotesId: "",
  },
  {
    id: "block-power-clean",
    fitNotesId: "",
  },
  {
    id: "boat-stretch",
    fitNotesId: "",
  },
  {
    id: "body-saw-plank",
    fitNotesId: "",
  },
  {
    id: "body-up",
    fitNotesId: "",
  },
  {
    id: "bodyweight-bent-over-rear-delt-raise",
    fitNotesId: "",
  },
  {
    id: "bodyweight-bulgarian-split-squat",
    fitNotesId: "",
  },
  {
    id: "bodyweight-calf-raise",
    fitNotesId: "",
  },
  {
    id: "bodyweight-glute-bridge",
    fitNotesId: "",
  },
  {
    id: "bodyweight-good-morning-squat",
    fitNotesId: "",
  },
  {
    id: "bodyweight-hip-thrust",
    fitNotesId: "",
  },
  {
    id: "bodyweight-jump-squat",
    fitNotesId: "",
  },
  {
    id: "bodyweight-overhead-squat",
    fitNotesId: "",
  },
  {
    id: "bodyweight-rear-lunge",
    fitNotesId: "",
  },
  {
    id: "bodyweight-russian-twist",
    fitNotesId: "",
  },
  {
    id: "bodyweight-single-leg-deadlift",
    fitNotesId: "",
  },
  {
    id: "bodyweight-sissy-squat",
    fitNotesId: "",
  },
  {
    id: "bodyweight-skull-crusher",
    fitNotesId: "",
  },
  {
    id: "bodyweight-standing-overhead-press",
    fitNotesId: "",
  },
  {
    id: "bodyweight-standing-sissy-squat",
    fitNotesId: "",
  },
  {
    id: "bodyweight-sumo-squat",
    fitNotesId: "",
  },
  {
    id: "bodyweight-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "bodyweight-windmill",
    fitNotesId: "",
  },
  {
    id: "bosu-ball-bodyweight-squat",
    fitNotesId: "",
  },
  {
    id: "bosu-ball-crunch",
    fitNotesId: "",
  },
  {
    id: "bosu-ball-push-up",
    fitNotesId: "",
  },
  {
    id: "bosu-ball-single-leg-balance",
    fitNotesId: "",
  },
  {
    id: "box-hip-flexor-stretch",
    fitNotesId: "",
  },
  {
    id: "box-jump",
    fitNotesId: "",
  },
  {
    id: "box-pistol-squat",
    fitNotesId: "",
  },
  {
    id: "briskly-walking",
    fitNotesId: "",
  },
  {
    id: "burpees",
    fitNotesId: "Burpees",
  },
  {
    id: "butt-kicks",
    fitNotesId: "",
  },
  {
    id: "butterfly-yoga-pose",
    fitNotesId: "",
  },
  {
    id: "bycicle-crunch",
    fitNotesId: "",
  },
  {
    id: "bycicle",
    fitNotesId: "",
  },
  {
    id: "cable-asssisted-inverse-leg-curl",
    fitNotesId: "",
  },
  {
    id: "cable-bench-press",
    fitNotesId: "",
  },
  {
    id: "cable-bent-over-reverse-fly",
    fitNotesId: "",
  },
  {
    id: "cable-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "cable-biceps-curl",
    fitNotesId: "Cable Curl",
  },
  {
    id: "cable-crossover-lat-pulldown",
    fitNotesId: "",
  },
  {
    id: "cable-crossover",
    fitNotesId: "Cable Crossover",
  },
  {
    id: "cable-deadlift",
    fitNotesId: "",
  },
  {
    id: "cable-decline-chest-fly",
    fitNotesId: "",
  },
  {
    id: "cable-decline-seated-wide-grip-row",
    fitNotesId: "",
  },
  {
    id: "cable-face-pull",
    fitNotesId: "Cable Face Pull",
  },
  {
    id: "cable-glute-kickback",
    fitNotesId: "",
  },
  {
    id: "cable-hammer-curl",
    fitNotesId: "",
  },
  {
    id: "cable-hip-abduction",
    fitNotesId: "",
  },
  {
    id: "cable-horizontal-pallof-press",
    fitNotesId: "",
  },
  {
    id: "cable-neutral-grip-kickback",
    fitNotesId: "",
  },
  {
    id: "cable-oblique-twist",
    fitNotesId: "",
  },
  {
    id: "cable-overhead-triceps-extension",
    fitNotesId: "Cable Overhead Triceps Extension",
  },
  {
    id: "cable-palm-rotational-row",
    fitNotesId: "",
  },
  {
    id: "cable-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "cable-pull-through",
    fitNotesId: "",
  },
  {
    id: "cable-pushdown",
    fitNotesId: "",
  },
  {
    id: "cable-rear-delt-fly",
    fitNotesId: "",
  },
  {
    id: "cable-rear-delt-row",
    fitNotesId: "",
  },
  {
    id: "cable-rear-drive",
    fitNotesId: "",
  },
  {
    id: "cable-rope-crossover-seated-row",
    fitNotesId: "",
  },
  {
    id: "cable-rope-rear-delt-row",
    fitNotesId: "",
  },
  {
    id: "cable-seated-neck-extension",
    fitNotesId: "",
  },
  {
    id: "cable-seated-neck-flexion",
    fitNotesId: "",
  },
  {
    id: "cable-shrug",
    fitNotesId: "",
  },
  {
    id: "cable-side-bend",
    fitNotesId: "",
  },
  {
    id: "cable-squat-row",
    fitNotesId: "",
  },
  {
    id: "cable-triceps-kickback",
    fitNotesId: "",
  },
  {
    id: "cable-tuck-reverse-crunch",
    fitNotesId: "",
  },
  {
    id: "cable-twin-handle-parallell-grip-lat-pulldown",
    fitNotesId: "",
  },
  {
    id: "cable-upright-row",
    fitNotesId: "",
  },
  {
    id: "cable-wrist-curl",
    fitNotesId: "",
  },
  {
    id: "cable-y-raise",
    fitNotesId: "",
  },
  {
    id: "calf-foam-roll",
    fitNotesId: "",
  },
  {
    id: "calf-press-leg-press-machine",
    fitNotesId: "",
  },
  {
    id: "calf-raise-from-deficit-with-support",
    fitNotesId: "",
  },
  {
    id: "calf-stair-stretch",
    fitNotesId: "",
  },
  {
    id: "calf-stretch-with-band",
    fitNotesId: "",
  },
  {
    id: "captain-chair-leg-raise",
    fitNotesId: "",
  },
  {
    id: "captain-chair-side-hip-raise",
    fitNotesId: "",
  },
  {
    id: "cat-cow-stretch",
    fitNotesId: "",
  },
  {
    id: "cat-stretch",
    fitNotesId: "",
  },
  {
    id: "ceiling-look-stretch",
    fitNotesId: "",
  },
  {
    id: "chest-dips",
    fitNotesId: "Dips",
  },
  {
    id: "chest-fly-machine",
    fitNotesId: "Seated Machine Fly",
  },
  {
    id: "chest-supported-cable-row",
    fitNotesId: "",
  },
  {
    id: "chest-supported-machine-row",
    fitNotesId: "Chest Supported Machine Row",
  },
  {
    id: "chest-tap-push-up",
    fitNotesId: "",
  },
  {
    id: "chin-to-chest-stretch",
    fitNotesId: "",
  },
  {
    id: "chin-up",
    fitNotesId: "Chin Up",
  },
  {
    id: "clap-push-up",
    fitNotesId: "",
  },
  {
    id: "clean-and-jerk",

    fitNotesId: "",
  },
  {
    id: "clean-and-press",

    fitNotesId: "",
  },
  {
    id: "clean-deadlift",
    fitNotesId: "",
  },
  {
    id: "close-grip-barbell-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "close-grip-chin-up",
    fitNotesId: "",
  },
  {
    id: "close-grip-dumbbell-bench-press",
    fitNotesId: "",
  },
  {
    id: "close-grip-knee-push-up",
    fitNotesId: "",
  },
  {
    id: "close-grip-lat-pulldown",
    fitNotesId: "",
  },
  {
    id: "close-grip-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "close-grip-pull-up",
    fitNotesId: "Close Grip Pull Up",
  },
  {
    id: "close-grip-push-up",
    fitNotesId: "",
  },
  {
    id: "close-grip-single-dumbbell-press",
    fitNotesId: "",
  },
  {
    id: "cobra-push-up",
    fitNotesId: "",
  },
  {
    id: "cobra-yoga-pose",
    fitNotesId: "",
  },
  {
    id: "commando-pull-up",
    fitNotesId: "",
  },
  {
    id: "concentration-curl",
    fitNotesId: "Dumbbell Concentration Curl",
  },
  {
    id: "corner-wall-chest-stretch",
    fitNotesId: "",
  },
  {
    id: "cossack-squats",
    fitNotesId: "",
  },
  {
    id: "counterbalanced-skater-squat",
    fitNotesId: "",
  },
  {
    id: "cow-face-pose-stretch",
    fitNotesId: "",
  },
  {
    id: "cow-stretch",
    fitNotesId: "",
  },
  {
    id: "crab-twist-toe-touch",
    fitNotesId: "",
  },
  {
    id: "criss-cross-leg-raise",
    fitNotesId: "",
  },
  {
    id: "cross-body-hammer-curl",
    fitNotesId: "",
  },
  {
    id: "cross-body-shoulder-stretch",
    fitNotesId: "",
  },
  {
    id: "crossed-arm-barbell-front-squat",
    fitNotesId: "",
  },
  {
    id: "crossover-cable-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "crossover-kneeling-hip-flexor-stretch",
    fitNotesId: "",
  },
  {
    id: "curtesy-squat",
    fitNotesId: "",
  },
  {
    id: "dead-bug",
    fitNotesId: "",
  },
  {
    id: "decline-barbell-bench-press",
    fitNotesId: "Decline Barbell Bench Press",
  },
  {
    id: "decline-barbell-pullover",
    fitNotesId: "",
  },
  {
    id: "decline-crunch",
    fitNotesId: "Decline Crunch",
  },
  {
    id: "decline-dumbbell-bench-press",
    fitNotesId: "",
  },
  {
    id: "decline-dumbbell-shrug",
    fitNotesId: "",
  },
  {
    id: "decline-kneeling-box-push-up",
    fitNotesId: "",
  },
  {
    id: "decline-push-up-against-wall",
    fitNotesId: "",
  },
  {
    id: "decline-push-up",
    fitNotesId: "",
  },
  {
    id: "decline-reverse-crunch",
    fitNotesId: "",
  },
  {
    id: "decline-shoulder-tap",
    fitNotesId: "",
  },
  {
    id: "decline-sit-up",
    fitNotesId: "",
  },

  {
    id: "decline-twisting-sit-up",
    fitNotesId: "",
  },
  {
    id: "diamond-push-up",
    fitNotesId: "Diamond Push Up",
  },
  {
    id: "dips-between-chairs",
    fitNotesId: "",
  },
  {
    id: "donkey-calf-raise",
    fitNotesId: "Donkey Calf Raise",
  },
  {
    id: "double-bench-dips",
    fitNotesId: "",
  },
  {
    id: "double-kettlebell-push-press",
    fitNotesId: "",
  },
  {
    id: "double-lean-back-quadriceps-stretch",
    fitNotesId: "",
  },
  {
    id: "arnold-dumbbell-press",
    fitNotesId: "",
  },
  {
    id: "dumbbell-behind-back-finger-curl",
    fitNotesId: "",
  },
  {
    id: "dumbbell-bench-hammer-press",
    fitNotesId: "",
  },
  {
    id: "dumbbell-box-squat",
    fitNotesId: "",
  },
  {
    id: "dumbbell-bent-over-delt-row",
    fitNotesId: "",
  },
  {
    id: "dumbbell-bent-over-raise",
    fitNotesId: "Rear Delt Dumbbell Raise",
  },
  {
    id: "dumbbell-bent-over-row",
    fitNotesId: "Dumbbell Row",
  },
  {
    id: "dumbbell-bulgarian-split-squat",
    fitNotesId: "",
  },
  {
    id: "dumbbell-chest-supported-lateral-raises",
    fitNotesId: "",
  },
  {
    id: "dumbbell-clean",
    fitNotesId: "",
  },
  {
    id: "dumbbell-dead-row",
    fitNotesId: "Dumbbell Dead Row",
  },
  {
    id: "dumbbell-deadlift",
    fitNotesId: "",
  },
  {
    id: "dumbbell-decline-fly",
    fitNotesId: "",
  },
  {
    id: "dumbbell-decline-overhead-sit-up",
    fitNotesId: "",
  },
  {
    id: "dumbbell-decline-single-arm-hammer-press",
    fitNotesId: "",
  },
  {
    id: "dumbbell-decline-twist-fly",
    fitNotesId: "",
  },
  {
    id: "dumbbell-external-rotation",
    fitNotesId: "",
  },
  {
    id: "dumbbell-farmers-walk",
    fitNotesId: "Farmer's Walk",
  },
  {
    id: "dumbbell-floor-fly",
    fitNotesId: "Eccentric Floor Chest Fly",
  },
  {
    id: "dumbbell-floor-press",
    fitNotesId: "Dumbbell Floor Press",
  },
  {
    id: "dumbbell-fly",
    fitNotesId: "Flat Dumbbell Fly",
  },
  {
    id: "dumbbell-front-rack-lunge",
    fitNotesId: "",
  },
  {
    id: "dumbbell-front-raise",
    fitNotesId: "Front Dumbbell Raise",
  },
  {
    id: "dumbbell-front-squat",
    fitNotesId: "",
  },
  {
    id: "dumbbell-glute-bridge",
    fitNotesId: "",
  },
  {
    id: "dumbbell-goblet-split-squat-front-foot-elevanted",
    fitNotesId: "",
  },
  {
    id: "dumbbell-hammer-curl",
    fitNotesId: "Dumbbell Hammer Curl",
  },
  {
    id: "dumbbell-hamstring-curl",
    fitNotesId: "",
  },
  {
    id: "dumbbell-incline-bench-press-palm-in",
    fitNotesId: "",
  },
  {
    id: "dumbbell-incline-bench-y-raise",
    fitNotesId: "",
  },
  {
    id: "dumbbell-incline-breeding",
    fitNotesId: "",
  },
  {
    id: "dumbbell-incline-hammer-curl",
    fitNotesId: "",
  },
  {
    id: "dumbbell-incline-hammer-press",
    fitNotesId: "",
  },
  {
    id: "dumbbell-incline-overhead-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "dumbbell-incline-single-arm-bench-press",
    fitNotesId: "",
  },
  {
    id: "dumbbell-incline-single-arm-hammer-press",
    fitNotesId: "",
  },
  {
    id: "dumbbell-incline-single-arm-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "dumbbell-iron-cross",
    fitNotesId: "",
  },
  {
    id: "dumbbell-lateral-step-up",
    fitNotesId: "",
  },
  {
    id: "dumbbell-low-fly",
    fitNotesId: "",
  },
  {
    id: "dumbbell-lunge",
    fitNotesId: "",
  },
  {
    id: "dumbbell-lying-hamstring-curl",
    fitNotesId: "",
  },
  {
    id: "dumbbell-lying-one-arm-rear-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "dumbbell-lying-rear-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "dumbbell-lying-single-arm-rear-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "single-arm-dumbbell-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "dumbbell-overhead-squat",
    fitNotesId: "",
  },
  {
    id: "dumbbell-plyo-squat",
    fitNotesId: "",
  },
  {
    id: "dumbbell-preacher-curl",
    fitNotesId: "Dumbbell Preacher Curl",
  },
  {
    id: "dumbbell-pronated-grip-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "dumbbell-pullover",
    fitNotesId: "",
  },
  {
    id: "dumbbell-push-press",

    fitNotesId: "",
  },
  {
    id: "dumbbell-push-up",
    fitNotesId: "",
  },
  {
    id: "rear-dumbbell-delt-fly",
    fitNotesId: "",
  },
  {
    id: "dumbbell-rear-delt-row",
    fitNotesId: "",
  },
  {
    id: "dumbbell-renegade-row",
    fitNotesId: "",
  },
  {
    id: "dumbbell-reverse-grip-row",
    fitNotesId: "",
  },
  {
    id: "dumbbell-reverse-spider-curl",
    fitNotesId: "",
  },
  {
    id: "dumbbell-romanian-deadlift",
    fitNotesId: "",
  },
  {
    id: "dumbbell-seated-calf-raise",
    fitNotesId: "",
  },
  {
    id: "seated-dumbbell-lateral-raise",
    fitNotesId: "Seated Dumbbell Lateral Raise",
  },
  {
    id: "dumbbell-seated-overhead-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "dumbbell-seated-reverse-grip-single-arm-tricep-extension",
    fitNotesId: "",
  },
  {
    id: "dumbbell-seated-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "dumbbell-shrug",
    fitNotesId: "",
  },
  {
    id: "dumbbell-side-bend",
    fitNotesId: "",
  },
  {
    id: "dumbbell-side-bridge",
    fitNotesId: "",
  },
  {
    id: "dumbbell-side-lunge",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-arm-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-arm-hammer-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-arm-leaning-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-arm-reverse-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-arm-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-arm-triceps-kickback",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-arm-zottman-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-leg-calf-raise",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-leg-deadlift",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-leg-glute-bridge",
    fitNotesId: "",
  },
  {
    id: "dumbbell-single-leg-step-up",
    fitNotesId: "",
  },
  {
    id: "dumbbell-skull-crusher",
    fitNotesId: "",
  },
  {
    id: "dumbbell-split-squat",
    fitNotesId: "",
  },
  {
    id: "dumbbell-squat",
    fitNotesId: "",
  },
  {
    id: "dumbbell-squeeze-bench-press",
    fitNotesId: "Dumbbell Chest Squeeze",
  },
  {
    id: "dumbbell-standing-single-leg-calf-raise",
    fitNotesId: "",
  },
  {
    id: "dumbbell-standing-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "dumbbell-step-up",
    fitNotesId: "",
  },
  {
    id: "dumbbell-stiff-leg-deadlift",
    fitNotesId: "",
  },
  {
    id: "dumbbell-straight-arm-crunch",
    fitNotesId: "",
  },
  {
    id: "dumbbell-straight-leg-russian-twist",
    fitNotesId: "",
  },
  {
    id: "dumbbell-suitcase-carry",
    fitNotesId: "",
  },
  {
    id: "dumbbell-sumo-squat",
    fitNotesId: "",
  },
  {
    id: "dumbbell-swing",
    fitNotesId: "",
  },
  {
    id: "dumbbell-tate-press",
    fitNotesId: "",
  },
  {
    id: "dumbbell-thruster",
    fitNotesId: "",
  },
  {
    id: "dumbbell-upright-row",
    fitNotesId: "",
  },
  {
    id: "dumbbell-upright-shoulder-external-rotation",
    fitNotesId: "",
  },
  {
    id: "dumbbell-v-up",
    fitNotesId: "",
  },
  {
    id: "dumbbell-wrist-curl-over-bench",
    fitNotesId: "",
  },
  {
    id: "dumbbell-zottman-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "dynamic-back-stretch",
    fitNotesId: "",
  },
  {
    id: "dynamic-chest-stretch",
    fitNotesId: "",
  },
  {
    id: "elboew-circles",
    fitNotesId: "",
  },
  {
    id: "elbow-extension-and-supination-stretch",
    fitNotesId: "",
  },
  {
    id: "elbow-push-up",
    fitNotesId: "",
  },
  {
    id: "elbow-to-knee-side-plank",
    fitNotesId: "",
  },
  {
    id: "elevated-push-up",
    fitNotesId: "",
  },
  {
    id: "eliptical-trainer",
    fitNotesId: "Eliptical Trainer",
  },
  {
    id: "extension-and-inclination-neck-stretch",
    fitNotesId: "",
  },
  {
    id: "ez-bar-biceps-curl",
    fitNotesId: "EZ-Bar Curl",
  },
  {
    id: "ez-bar-close-grip-bench-press",
    fitNotesId: "",
  },
  {
    id: "ez-bar-close-grip-curl",
    fitNotesId: "",
  },
  {
    id: "ez-bar-preacher-curl",
    fitNotesId: "EZ-Bar Preacher Curl",
  },
  {
    id: "ez-bar-reverse-curl",
    fitNotesId: "",
  },
  {
    id: "ez-bar-reverse-grip-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "ez-bar-seated-close-grip-concentration-curl",
    fitNotesId: "",
  },
  {
    id: "ez-bar-skullcrusher",
    fitNotesId: "EZ-Bar Skullcrusher",
  },
  {
    id: "ez-bar-spider-curls",
    fitNotesId: "",
  },
  {
    id: "ez-bar-standing-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "ez-barbell-anti-gravity-press",
    fitNotesId: "",
  },
  {
    id: "ez-barbell-decline-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "ez-barbell-spider-curl",
    fitNotesId: "",
  },
  {
    id: "feet-and-ankles-rotation-stretch",
    fitNotesId: "",
  },
  {
    id: "feet-and-ankles-stretch",
    fitNotesId: "",
  },
  {
    id: "finger-push-up",
    fitNotesId: "",
  },
  {
    id: "fingers-down-forearm-stretch",
    fitNotesId: "",
  },
  {
    id: "fixed-bar-back-stretch",
    fitNotesId: "",
  },
  {
    id: "flat-barbell-bench-press",
    fitNotesId: "Flat Barbell Bench Press",
  },
  {
    id: "flat-barbell-wide-grip-bench-press",
    fitNotesId: "",
  },
  {
    id: "flat-bench-reverse-hyper-extension",
    fitNotesId: "",
  },
  {
    id: "flat-dumbbell-bench-press",
    fitNotesId: "Flat Dumbbell Bench Press",
  },
  {
    id: "flexion-and-extension-hip-stretch",
    fitNotesId: "",
  },
  {
    id: "flexion-leg-sit-up",
    fitNotesId: "",
  },
  {
    id: "floor-crunch",
    fitNotesId: "Crunch",
  },
  {
    id: "floor-dumbbell-pullover",
    fitNotesId: "",
  },
  {
    id: "floor-dumbbell-skull-crusher",
    fitNotesId: "",
  },
  {
    id: "floor-hyperextension",
    fitNotesId: "",
  },
  {
    id: "floor-leg-raise",
    fitNotesId: "",
  },
  {
    id: "floor-seated-bent-over-back-stretch",
    fitNotesId: "",
  },
  {
    id: "floor-seated-crunchy-frog",
    fitNotesId: "",
  },
  {
    id: "floor-triceps-dips",
    fitNotesId: "",
  },
  {
    id: "floor-v-sit",
    fitNotesId: "",
  },
  {
    id: "flutter-kicks",
    fitNotesId: "",
  },
  {
    id: "foam-roll-lat-stretch",
    fitNotesId: "",
  },
  {
    id: "foam-roller-hip-thrust",
    fitNotesId: "",
  },
  {
    id: "forearm-pronation-stretch",
    fitNotesId: "",
  },
  {
    id: "forearm-supination-stretch",
    fitNotesId: "",
  },
  {
    id: "forearms-push-up",
    fitNotesId: "",
  },
  {
    id: "forward-lunge",
    fitNotesId: "",
  },
  {
    id: "frog-crunch",
    fitNotesId: "",
  },
  {
    id: "frog-hip-thrust",
    fitNotesId: "",
  },
  {
    id: "frog-planche",
    fitNotesId: "",
  },
  {
    id: "frog-reverse-hyperextension",
    fitNotesId: "",
  },
  {
    id: "frog-squat",
    fitNotesId: "",
  },
  {
    id: "frogger-exercise",
    fitNotesId: "",
  },
  {
    id: "front-and-back-neck-stretch",
    fitNotesId: "",
  },
  {
    id: "front-foot-elevated-goblet-split-squat",
    fitNotesId: "",
  },
  {
    id: "front-incline-dumbbell-raise",
    fitNotesId: "",
  },
  {
    id: "front-lever-reps",
    fitNotesId: "",
  },
  {
    id: "front-plate-raise",
    fitNotesId: "",
  },
  {
    id: "front-toe-touching",
    fitNotesId: "",
  },
  {
    id: "full-squat",
    fitNotesId: "",
  },
  {
    id: "glute-bridge-march",
    fitNotesId: "",
  },
  {
    id: "glute-bridge-on-bench",
    fitNotesId: "",
  },
  {
    id: "glute-hamstring-raise",
    fitNotesId: "Glute-Ham Raise",
  },
  {
    id: "goblet-squat",
    fitNotesId: "",
  },
  {
    id: "good-morning",
    fitNotesId: "Good Morning",
  },
  {
    id: "groin-crunch",
    fitNotesId: "",
  },
  {
    id: "half-kneeling-band-chop",
    fitNotesId: "",
  },
  {
    id: "half-kneeling-band-face-pull",
    fitNotesId: "",
  },
  {
    id: "half-kneeling-band-single-arm-pulldown",
    fitNotesId: "",
  },
  {
    id: "half-kneeling-single-arm-kettlebell-press",
    fitNotesId: "",
  },
  {
    id: "half-kneeling-single-arm-landmine-press",
    fitNotesId: "",
  },
  {
    id: "half-turkish-get-up",
    fitNotesId: "",
  },
  {
    id: "half-wipers",
    fitNotesId: "",
  },
  {
    id: "hammer-dumbbell-floor-press",
    fitNotesId: "",
  },
  {
    id: "decline-hammer-strength-chest-press",
    fitNotesId: "Decline Hammer Strength Chest Press",
  },
  {
    id: "hammer-grip-pull-up",
    fitNotesId: "",
  },
  {
    id: "hamstring-foam-roller",
    fitNotesId: "",
  },
  {
    id: "hamstring-stretch",
    fitNotesId: "",
  },
  {
    id: "hands-on-chest-russian-twist",
    fitNotesId: "",
  },
  {
    id: "handstand-push-up",
    fitNotesId: "",
  },
  {
    id: "handstand-walk",
    fitNotesId: "",
  },
  {
    id: "hanging-dead-bug",
    fitNotesId: "",
  },
  {
    id: "hanging-knee-raise",
    fitNotesId: "",
  },
  {
    id: "hanging-leg-raise-with-arm-slings",
    fitNotesId: "",
  },
  {
    id: "hanging-leg-raise",
    fitNotesId: "Hanging Leg Raise",
  },
  {
    id: "hanging-toes-to-bar",
    fitNotesId: "",
  },
  {
    id: "high-band-chest-fly",
    fitNotesId: "",
  },
  {
    id: "high-cable-chest-fly",
    fitNotesId: "",
  },
  {
    id: "high-knee-run",
    fitNotesId: "",
  },
  {
    id: "high-knee-skips",
    fitNotesId: "",
  },
  {
    id: "high-knee-sprint",
    fitNotesId: "",
  },
  {
    id: "high-knee-squat",
    fitNotesId: "",
  },
  {
    id: "high-knee-walking-lunge",
    fitNotesId: "",
  },
  {
    id: "high-pulley-overhead-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "high-to-low-cable-oblique-twist",
    fitNotesId: "",
  },
  {
    id: "hip-circles-stretch",
    fitNotesId: "",
  },
  {
    id: "hip-flexor-foam-rolling",
    fitNotesId: "",
  },
  {
    id: "hip-twist-with-straight-arms",
    fitNotesId: "",
  },
  {
    id: "hollow-hold",
    fitNotesId: "",
  },
  {
    id: "horizontal-calf-press-leg-press-machine",
    fitNotesId: "",
  },
  {
    id: "horizontal-hyperextension",
    fitNotesId: "",
  },
  {
    id: "horizontal-machine-hack-squat",
    fitNotesId: "",
  },
  {
    id: "horizontal-shoulder-traverse-flexion-stretch",
    fitNotesId: "",
  },
  {
    id: "hyperextension",
    fitNotesId: "",
  },
  {
    id: "iliospsoas-foam-roll",
    fitNotesId: "",
  },
  {
    id: "iliospsoas-roll-ball",
    fitNotesId: "",
  },
  {
    id: "incline-barbell-bench-press",
    fitNotesId: "Incline Barbell Bench Press",
  },
  {
    id: "incline-barbell-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "incline-bench-barbell-row",
    fitNotesId: "",
  },
  {
    id: "incline-bench-cable-fly",
    fitNotesId: "",
  },
  {
    id: "incline-bench-dumbbell-rear-delt-row",
    fitNotesId: "",
  },
  {
    id: "incline-cable-chest-press",
    fitNotesId: "",
  },
  {
    id: "chest-press-machine",
    fitNotesId: "Chest Push Machine",
  },
  {
    id: "incline-dumbbell-bench-press",
    fitNotesId: "Incline Dumbbell Bench Press",
  },
  {
    id: "incline-dumbbell-curl",
    fitNotesId: "Seated Incline Dumbbell Curl",
  },
  {
    id: "incline-dumbbell-fly",
    fitNotesId: "Dumbbell Upper Fly",
  },
  {
    id: "incline-dumbbell-prone-hammer-curl",
    fitNotesId: "",
  },
  {
    id: "incline-dumbbell-row",
    fitNotesId: "",
  },
  {
    id: "incline-dumbbell-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "incline-inner-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "incline-leg-hip-raise",
    fitNotesId: "",
  },
  {
    id: "incline-machine-shoulder-press",
    fitNotesId: "Hammer Strength Shoulder Press",
  },
  {
    id: "incline-push-up",
    fitNotesId: "Bar Push Ups",
  },
  {
    id: "incline-bench-triceps-push-up",
    fitNotesId: "Incline Bench Triceps Push",
  },
  {
    id: "incline-rear-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "incline-shoulder-tap",
    fitNotesId: "",
  },
  {
    id: "inverse-leg-curl",
    fitNotesId: "",
  },
  {
    id: "inverted-row-between-chairs",
    fitNotesId: "",
  },
  {
    id: "inverted-row",
    fitNotesId: "",
  },
  {
    id: "iron-cross-stretch",
    fitNotesId: "",
  },
  {
    id: "jab-boxing",
    fitNotesId: "",
  },
  {
    id: "janda-sit-up",
    fitNotesId: "",
  },
  {
    id: "jefferson-split-squat",
    fitNotesId: "",
  },
  {
    id: "jefferson-squat",
    fitNotesId: "",
  },
  {
    id: "jog-in-place",

    fitNotesId: "",
  },
  {
    id: "jump-pistol-squat",
    fitNotesId: "",
  },
  {
    id: "jump-step-up",
    fitNotesId: "",
  },
  {
    id: "jumping-pull-up",
    fitNotesId: "",
  },
  {
    id: "jumping-rope",
    fitNotesId: "",
  },
  {
    id: "ketllebell-swing",

    fitNotesId: "",
  },
  {
    id: "kettlebell-advanced-windmill",
    fitNotesId: "",
  },
  {
    id: "kettlebell-alternating-row",
    fitNotesId: "",
  },
  {
    id: "kettlebell-angled-press",
    fitNotesId: "",
  },
  {
    id: "kettlebell-arnold-press",
    fitNotesId: "",
  },
  {
    id: "kettlebell-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "kettlebell-bent-press",
    fitNotesId: "",
  },
  {
    id: "kettlebell-bottom-up-press",
    fitNotesId: "",
  },
  {
    id: "kettlebell-deadlift",
    fitNotesId: "",
  },
  {
    id: "kettlebell-farmers-walk",
    fitNotesId: "",
  },
  {
    id: "kettlebell-half-kneeling-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "kettlebell-halo",
    fitNotesId: "",
  },
  {
    id: "kettlebell-hang-clean",
    fitNotesId: "",
  },
  {
    id: "kettlebell-pistol-squat",
    fitNotesId: "",
  },
  {
    id: "kettlebell-russian-twist",
    fitNotesId: "",
  },
  {
    id: "kettlebell-single-arm-overhead-squat",
    fitNotesId: "",
  },
  {
    id: "kettlebell-single-arm-row",
    fitNotesId: "",
  },
  {
    id: "kettlebell-single-leg-deadlift",
    fitNotesId: "",
  },
  {
    id: "kettlebell-step-up",
    fitNotesId: "",
  },
  {
    id: "kettlebell-straight-leg-deadlift",
    fitNotesId: "",
  },
  {
    id: "kettlebell-strict-press",
    fitNotesId: "",
  },
  {
    id: "kettlebell-suitcase-deadlift",
    fitNotesId: "",
  },
  {
    id: "kettlebell-sumo-deadlift-with-high-pull",
    fitNotesId: "",
  },
  {
    id: "kettlebell-sumo-high-pull",
    fitNotesId: "",
  },
  {
    id: "kettlebell-sumo-squat",
    fitNotesId: "",
  },
  {
    id: "kettlebell-swing",
    fitNotesId: "",
  },
  {
    id: "kettlebell-two-arm-overhead-press",
    fitNotesId: "",
  },
  {
    id: "kettlebell-upright-row",
    fitNotesId: "",
  },
  {
    id: "knee-decline-push-up",
    fitNotesId: "",
  },
  {
    id: "knee-diamond-push-up",
    fitNotesId: "",
  },
  {
    id: "kneeled-shoulder-press",
    fitNotesId: "Kneeled Shoulder Press",
  },
  {
    id: "knee-push-up",
    fitNotesId: "",
  },
  {
    id: "knee-to-chest-single-leg-glute-bridge",
    fitNotesId: "",
  },
  {
    id: "knee-touch-crunch",
    fitNotesId: "",
  },
  {
    id: "knee-tuck-jump",
    fitNotesId: "",
  },
  {
    id: "kneeling-back-rotation-stretch",
    fitNotesId: "",
  },
  {
    id: "kneeling-band-crunch",
    fitNotesId: "",
  },
  {
    id: "kneeling-barbell-squats",
    fitNotesId: "",
  },
  {
    id: "kneeling-cable-crunch",
    fitNotesId: "Cable Crunch",
  },
  {
    id: "kneeling-cable-rear-delt-row",
    fitNotesId: "",
  },
  {
    id: "kneeling-crossover-hip-flexor-stretch",
    fitNotesId: "",
  },
  {
    id: "kneeling-hip-flexor-stretch",
    fitNotesId: "",
  },
  {
    id: "kneeling-landmine-squeeze-press",
    fitNotesId: "",
  },
  {
    id: "kneeling-lat-stretch",
    fitNotesId: "",
  },
  {
    id: "kneeling-leg-curl-machine",
    fitNotesId: "",
  },
  {
    id: "kneeling-leg-half-circle",
    fitNotesId: "",
  },
  {
    id: "kneeling-overhead-dumbbell-hold-to-stand",
    fitNotesId: "",
  },
  {
    id: "kneeling-plank",
    fitNotesId: "",
  },
  {
    id: "kneeling-shoulder-tap-push-up",
    fitNotesId: "",
  },
  {
    id: "kneeling-shoulder-tap",
    fitNotesId: "",
  },
  {
    id: "kneeling-toe-up-hamstring-stretch",
    fitNotesId: "",
  },
  {
    id: "kneeling-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "knuckle-push-up",
    fitNotesId: "Punch Push Up",
  },
  {
    id: "landmine-180",
    fitNotesId: "",
  },
  {
    id: "landmine-front-squat",
    fitNotesId: "",
  },
  {
    id: "landmine-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "landmine-reverse-lunge",
    fitNotesId: "",
  },
  {
    id: "landmine-romanian-deadlift",
    fitNotesId: "",
  },
  {
    id: "landmine-single-arm-bent-row",
    fitNotesId: "",
  },
  {
    id: "landmine-single-arm-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "landmine-single-leg-romanian-deadlift",
    fitNotesId: "",
  },
  {
    id: "landmine-squat-and-press",
    fitNotesId: "",
  },
  {
    id: "landmine-sumo-squat",
    fitNotesId: "",
  },
  {
    id: "lat-foam-rolling",
    fitNotesId: "",
  },
  {
    id: "lat-pulldown",
    fitNotesId: "Lat Pulldown",
  },
  {
    id: "lateral-box-jump",
    fitNotesId: "",
  },
  {
    id: "dumbbell-lateral-raise",
    fitNotesId: "Lateral Dumbbell Raise",
  },
  {
    id: "lateral-step-up",
    fitNotesId: "",
  },
  {
    id: "lateral-vastus-roll-ball",
    fitNotesId: "",
  },
  {
    id: "left-hook-boxing",
    fitNotesId: "",
  },
  {
    id: "left-upercut-boxing",
    fitNotesId: "",
  },
  {
    id: "leg-extension-machine",
    fitNotesId: "Leg Extension Machine",
  },
  {
    id: "leg-swing",
    fitNotesId: "",
  },
  {
    id: "leg-tuck-hip-stretch",
    fitNotesId: "",
  },
  {
    id: "lever-deadlift",
    fitNotesId: "",
  },
  {
    id: "lever-gripless-shrug",
    fitNotesId: "",
  },
  {
    id: "lever-lateral-raise-machine",
    fitNotesId: "",
  },
  {
    id: "lever-lying-crunch",
    fitNotesId: "",
  },
  {
    id: "lever-peck-deck-fly",
    fitNotesId: "",
  },
  {
    id: "lever-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "lever-reverse-t-bar-row",
    fitNotesId: "",
  },
  {
    id: "lever-seated-calf-raise",
    fitNotesId: "",
  },
  {
    id: "lever-seated-hip-abduction",
    fitNotesId: "",
  },
  {
    id: "lever-seated-reverse-fly",
    fitNotesId: "",
  },
  {
    id: "lever-shrug",
    fitNotesId: "Machine Shrug",
  },
  {
    id: "lever-standing-calf-raise",
    fitNotesId: "",
  },
  {
    id: "log-press",
    fitNotesId: "Log Press",
  },
  {
    id: "long-arm-crunch",
    fitNotesId: "",
  },
  {
    id: "low-cable-chest-fly",
    fitNotesId: "",
  },
  {
    id: "low-to-high-cable-twist",
    fitNotesId: "",
  },
  {
    id: "lower-back-foam-roll",
    fitNotesId: "",
  },
  {
    id: "lying-abductor-stretch",
    fitNotesId: "",
  },
  {
    id: "lying-cable-fly",
    fitNotesId: "",
  },
  {
    id: "lying-cable-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "lying-cambered-bar-row",
    fitNotesId: "",
  },
  {
    id: "lying-chest-press-machine",
    fitNotesId: "",
  },
  {
    id: "lying-cross-over-knee-pull-down-stretch",
    fitNotesId: "",
  },
  {
    id: "lying-dumbbell-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "lying-elbow-to-knee-crunch",
    fitNotesId: "",
  },
  {
    id: "lying-glute-stretch",
    fitNotesId: "",
  },
  {
    id: "lying-hip-extension",
    fitNotesId: "",
  },
  {
    id: "lying-knee-to-chest-stretch",
    fitNotesId: "",
  },
  {
    id: "lying-leg-curl-machine",
    fitNotesId: "Lying Leg Curl Machine",
  },
  {
    id: "lying-leg-hip-raise-on-floor",
    fitNotesId: "",
  },
  {
    id: "lying-leg-hip-raise",
    fitNotesId: "",
  },
  {
    id: "lying-leg-raise-and-hold",
    fitNotesId: "",
  },
  {
    id: "lying-leg-raise",
    fitNotesId: "",
  },
  {
    id: "lying-lower-back-stretch",
    fitNotesId: "",
  },
  {
    id: "lying-rope-extension-cable-pullover",
    fitNotesId: "",
  },
  {
    id: "lying-single-arm-dumbbell-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "lying-single-leg-curl-machine",
    fitNotesId: "",
  },
  {
    id: "lying-single-leg-reverse-biceps-curl-with-towel",
    fitNotesId: "",
  },
  {
    id: "lying-supine-dumbbell-curl",
    fitNotesId: "",
  },
  {
    id: "lying-t-bar-row",
    fitNotesId: "",
  },
  {
    id: "machine-back-extension",
    fitNotesId: "",
  },
  {
    id: "machine-ball-close-grip-push-up",
    fitNotesId: "",
  },
  {
    id: "machine-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "machine-high-row",
    fitNotesId: "",
  },
  {
    id: "machine-hip-thrust",
    fitNotesId: "",
  },
  {
    id: "machine-horizontal-single-leg-press",
    fitNotesId: "",
  },
  {
    id: "machine-lat-pulldown",
    fitNotesId: "Lat Pull Down Machine",
  },
  {
    id: "lateral-machine-raise",
    fitNotesId: "Lateral Machine Raise",
  },
  {
    id: "machine-leg-extension",
    fitNotesId: "",
  },
  {
    id: "machine-low-row",
    fitNotesId: "",
  },
  {
    id: "machine-overhead-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "machine-pullover",
    fitNotesId: "",
  },
  {
    id: "machine-reverse-grip-high-row",
    fitNotesId: "",
  },
  {
    id: "reverse-hyperextension-machine",
    fitNotesId: "Reverse Hyperextension",
  },
  {
    id: "machine-rotary-calf",
    fitNotesId: "",
  },
  {
    id: "machine-row",
    fitNotesId: "",
  },
  {
    id: "machine-seated-leg-press",
    fitNotesId: "",
  },
  {
    id: "machine-seated-row",
    fitNotesId: "",
  },
  {
    id: "machine-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "machine-standing-hip-extension",
    fitNotesId: "",
  },
  {
    id: "machine-t-bar-row",
    fitNotesId: "T-Bar Row Machine",
  },
  {
    id: "machine-triceps-dips",
    fitNotesId: "",
  },
  {
    id: "machine-unilateral-row",
    fitNotesId: "",
  },
  {
    id: "marching-on-spot",
    fitNotesId: "",
  },
  {
    id: "medicine-ball-crunch",
    fitNotesId: "",
  },
  {
    id: "medicine-ball-overhead-slam",
    fitNotesId: "",
  },
  {
    id: "medicine-ball-push-up",
    fitNotesId: "",
  },
  {
    id: "medicine-ball-sit-up",
    fitNotesId: "",
  },
  {
    id: "middle-back-rotation-stretch",
    fitNotesId: "",
  },
  {
    id: "middle-cable-chest-fly",
    fitNotesId: "",
  },
  {
    id: "mountain-climber-lunge",
    fitNotesId: "",
  },
  {
    id: "mountain-climber",
    fitNotesId: "",
  },
  {
    id: "multi-purpose-vbar-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "narrow-grip-seated-row-machine",
    fitNotesId: "Hammer Strength Row",
  },
  {
    id: "narrow-stance-cable-squat",
    fitNotesId: "",
  },
  {
    id: "neck-circle-stretch",
    fitNotesId: "",
  },
  {
    id: "neck-flexion",
    fitNotesId: "",
  },
  {
    id: "neck-harness-side-bend",
    fitNotesId: "",
  },
  {
    id: "neck-side-stretch",
    fitNotesId: "",
  },
  {
    id: "negative-pull-up",
    fitNotesId: "Negative Pull Up",
  },
  {
    id: "neutral-grip-chin-up",
    fitNotesId: "Neutral Chin Up",
  },
  {
    id: "neutral-grip-pull-up",
    fitNotesId: "",
  },
  {
    id: "nordic-hamstring-curl",
    fitNotesId: "Nordic Curls",
  },
  {
    id: "oblique-crunch-with-straight-leg-lift",
    fitNotesId: "",
  },
  {
    id: "oblique-floor-crunch",
    fitNotesId: "",
  },
  {
    id: "open-book-stretch",
    fitNotesId: "",
  },
  {
    id: "otis-up",
    fitNotesId: "",
  },
  {
    id: "overhead-cable-curl",
    fitNotesId: "",
  },
  {
    id: "overhead-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "overhead-triceps-stretch",
    fitNotesId: "",
  },
  {
    id: "palm-rotational-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "parallel-bar-twisting-leg-raise",
    fitNotesId: "",
  },
  {
    id: "pelvic-tilt-into-bridge",
    fitNotesId: "",
  },
  {
    id: "pelvic-tilt",
    fitNotesId: "",
  },
  {
    id: "pendlay-row",
    fitNotesId: "Pendlay Row",
  },
  {
    id: "pigeon-hip-stretch",
    fitNotesId: "",
  },
  {
    id: "pike-bench-push-up",
    fitNotesId: "",
  },
  {
    id: "pike-push-up",
    fitNotesId: "",
  },
  {
    id: "pike-to-cobra-push",
    fitNotesId: "",
  },
  {
    id: "piriformis-release-ball",
    fitNotesId: "",
  },
  {
    id: "pistol-squat",
    fitNotesId: "",
  },
  {
    id: "planche-push-up",
    fitNotesId: "",
  },
  {
    id: "plank-arm-lifts",
    fitNotesId: "",
  },
  {
    id: "plank-jack",
    fitNotesId: "",
  },
  {
    id: "plank-toe-taps",
    fitNotesId: "",
  },
  {
    id: "plank-with-leg-lift",
    fitNotesId: "",
  },
  {
    id: "plank",
    fitNotesId: "Plank",
  },
  {
    id: "plate-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "plate-pinch",
    fitNotesId: "",
  },
  {
    id: "plate-russian-twist",
    fitNotesId: "",
  },
  {
    id: "plate-svend-press",
    fitNotesId: "",
  },
  {
    id: "plyo-lateral-lunge",
    fitNotesId: "",
  },
  {
    id: "posterior-deltoid-ball-rolling",
    fitNotesId: "",
  },
  {
    id: "power-sled-push",
    fitNotesId: "",
  },
  {
    id: "preacher-curl-machine",
    fitNotesId: "Seated Machine Curl",
  },
  {
    id: "preacher-hammer-curl",
    fitNotesId: "",
  },
  {
    id: "prone-incline-dumbbell-curl",
    fitNotesId: "",
  },
  {
    id: "prone-press-swan",
    fitNotesId: "",
  },
  {
    id: "pseudo-planche-push-up",
    fitNotesId: "",
  },
  {
    id: "pull-up",
    fitNotesId: "Pull Up",
  },
  {
    id: "pulse-row",
    fitNotesId: "",
  },
  {
    id: "pulse-squat",
    fitNotesId: "",
  },
  {
    id: "pulse-up",
    fitNotesId: "",
  },
  {
    id: "push-press",
    fitNotesId: "Push Press",
  },
  {
    id: "push-up-plus",
    fitNotesId: "",
  },
  {
    id: "push-up-with-rotation",
    fitNotesId: "",
  },
  {
    id: "push-up",
    fitNotesId: "Push Up",
  },
  {
    id: "pvc-bent-over-twist",
    fitNotesId: "",
  },
  {
    id: "pvc-external-rotation-stretch",
    fitNotesId: "",
  },
  {
    id: "pvc-front-rack-stretch",
    fitNotesId: "",
  },
  {
    id: "pvc-good-morning",
    fitNotesId: "",
  },
  {
    id: "pvc-hip-hinge",
    fitNotesId: "",
  },
  {
    id: "pvc-overhead-squat",
    fitNotesId: "",
  },
  {
    id: "pvc-pass-through-stretch",
    fitNotesId: "",
  },
  {
    id: "quadriceps-lying-stretch",
    fitNotesId: "",
  },
  {
    id: "quadriceps-stretch",
    fitNotesId: "",
  },
  {
    id: "quick-feet",
    fitNotesId: "",
  },
  {
    id: "raised-legs-crunch",
    fitNotesId: "",
  },
  {
    id: "rear-dumbbell-lunge",
    fitNotesId: "",
  },
  {
    id: "rear-foot-elevated-hip-flexor-dynamic-stretch",
    fitNotesId: "",
  },
  {
    id: "rectus-femoris-foam-rolling",
    fitNotesId: "",
  },
  {
    id: "recumbent-bike",
    fitNotesId: "",
  },
  {
    id: "recumbent-hip-external-rotator-and-hip-extensor-foam-roll",
    fitNotesId: "",
  },
  {
    id: "resistance-band-bent-leg-side-kick",
    fitNotesId: "",
  },
  {
    id: "resistance-band-bicycle-crunch",
    fitNotesId: "",
  },
  {
    id: "resistance-band-clam",
    fitNotesId: "",
  },
  {
    id: "resistance-band-glute-bridge",
    fitNotesId: "",
  },
  {
    id: "resistance-band-lateral-walk",
    fitNotesId: "",
  },
  {
    id: "resistance-band-leg-kickback",
    fitNotesId: "",
  },
  {
    id: "resistance-band-lying-leg-raise",
    fitNotesId: "",
  },
  {
    id: "resistance-band-seated-hip-abduction",
    fitNotesId: "",
  },
  {
    id: "resistance-band-single-leg-kickback",
    fitNotesId: "",
  },
  {
    id: "resistance-band-triceps-pushdown",
    fitNotesId: "",
  },
  {
    id: "resistance-band-face-pull",
    fitNotesId: "",
  },
  {
    id: "reverse-barbell-curl",
    fitNotesId: "",
  },
  {
    id: "reverse-cable-curl",
    fitNotesId: "",
  },
  {
    id: "reverse-crunch",
    fitNotesId: "",
  },
  {
    id: "reverse-dumbbell-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "reverse-elbow-push-up",
    fitNotesId: "",
  },
  {
    id: "reverse-grip-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "reverse-grip-dumbbell-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "reverse-grip-lat-pulldown-machine",
    fitNotesId: "",
  },
  {
    id: "reverse-grip-pull-up",
    fitNotesId: "",
  },
  {
    id: "reverse-grip-pulldown",
    fitNotesId: "",
  },
  {
    id: "reverse-grip-triceps-pushdown",
    fitNotesId: "",
  },
  {
    id: "reverse-plank-with-leg-lift",
    fitNotesId: "",
  },
  {
    id: "reverse-plank",
    fitNotesId: "",
  },
  {
    id: "reverse-push-up",
    fitNotesId: "",
  },
  {
    id: "right-hook-boxing",
    fitNotesId: "",
  },
  {
    id: "right-uppercut-boxing",
    fitNotesId: "",
  },
  {
    id: "ring-dips",
    fitNotesId: "Ring Dip",
  },
  {
    id: "ring-muscle-up",
    fitNotesId: "",
  },
  {
    id: "rocking-frog-stretch",
    fitNotesId: "",
  },
  {
    id: "roll-pec-foam-rolling",
    fitNotesId: "",
  },
  {
    id: "rolling-back-stretch",
    fitNotesId: "",
  },
  {
    id: "roman-chair-sit-up",
    fitNotesId: "",
  },
  {
    id: "romanian-deadlift",
    fitNotesId: "Romanian Deadlift",
  },
  {
    id: "rope-cable-machine-hammer-curls",
    fitNotesId: "",
  },
  {
    id: "rope-lat-pulldown",
    fitNotesId: "",
  },
  {
    id: "rope-seated-row",
    fitNotesId: "",
  },
  {
    id: "rotating-neck-stretch",
    fitNotesId: "",
  },
  {
    id: "rotational-push-up",
    fitNotesId: "",
  },
  {
    id: "rowing-machine",
    fitNotesId: "Rowing Machine",
  },
  {
    id: "run-on-treadmill",
    fitNotesId: "Running (Treadmill)",
  },
  {
    id: "running",
    fitNotesId: "Running (Outdoor)",
  },
  {
    id: "scapula-dips",
    fitNotesId: "",
  },
  {
    id: "scapular-pull-up",
    fitNotesId: "",
  },
  {
    id: "scapular-slide-back-to-wall",
    fitNotesId: "",
  },
  {
    id: "scissors",
    fitNotesId: "",
  },
  {
    id: "seated-shoulder-flexor-depressor-retractor-stretch",
    fitNotesId: "",
  },
  {
    id: "seated-8-leg-crunch",
    fitNotesId: "",
  },
  {
    id: "seated-abdominal-crunch-machine",
    fitNotesId: "Crunch Machine",
  },
  {
    id: "seated-barbell-twist",
    fitNotesId: "",
  },
  {
    id: "seated-behind-the-neck-overhead-press",
    fitNotesId: "",
  },
  {
    id: "seated-cable-crunch",
    fitNotesId: "",
  },
  {
    id: "seated-cable-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "seated-calf-stretch",
    fitNotesId: "",
  },
  {
    id: "seated-close-grip-concentration-curl",
    fitNotesId: "",
  },
  {
    id: "seated-dips-machine",
    fitNotesId: "",
  },
  {
    id: "seated-dumbbell-curl",
    fitNotesId: "",
  },
  {
    id: "seated-dumbbell-overhead-press",
    fitNotesId: "Seated Dumbbell Press",
  },
  {
    id: "seated-dumbbell-reverse-fly",
    fitNotesId: "",
  },
  {
    id: "seated-dumbbell-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "seated-glute-stretch",
    fitNotesId: "",
  },
  {
    id: "seated-good-morning",
    fitNotesId: "",
  },
  {
    id: "seated-hamstring-stretch",
    fitNotesId: "",
  },
  {
    id: "seated-hip-internal-rotation",
    fitNotesId: "",
  },
  {
    id: "seated-kettlebell-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "seated-leg-curl-machine",
    fitNotesId: "",
  },
  {
    id: "seated-leg-raise-crunch-machine",
    fitNotesId: "",
  },
  {
    id: "seated-leg-raise",
    fitNotesId: "",
  },
  {
    id: "seated-lower-back-stretch",
    fitNotesId: "",
  },
  {
    id: "seated-calf-raise-machine",
    fitNotesId: "",
  },
  {
    id: "seated-machine-reverse-fly",
    fitNotesId: "Rear Delt Machine Fly",
  },
  {
    id: "seated-overhead-press",
    fitNotesId: "Seated Overhead Press",
  },
  {
    id: "seated-neck-extension",
    fitNotesId: "",
  },
  {
    id: "seated-neck-flexion-and-extension",
    fitNotesId: "",
  },
  {
    id: "seated-neutral-dumbbell-wrist-curl",
    fitNotesId: "",
  },
  {
    id: "seated-overhead-dumbbell-press",
    fitNotesId: "",
  },
  {
    id: "seated-piriformis-stretch",
    fitNotesId: "",
  },
  {
    id: "seated-reverse-grip-concentration-curl",
    fitNotesId: "",
  },
  {
    id: "seated-row-machine",
    fitNotesId: "Row Machine",
  },
  {
    id: "seated-single-arm-cable-row",
    fitNotesId: "",
  },
  {
    id: "seated-single-arm-dumbbell-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "seated-single-leg-curl-machine",
    fitNotesId: "",
  },
  {
    id: "seated-squat-machine-calf-raise",
    fitNotesId: "",
  },
  {
    id: "seated-straight-leg-calf-stretch",
    fitNotesId: "",
  },
  {
    id: "seated-swiss-bar-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "seated-triceps-kickback",
    fitNotesId: "",
  },
  {
    id: "seated-twist-machine",
    fitNotesId: "",
  },
  {
    id: "seated-twist",
    fitNotesId: "",
  },
  {
    id: "kettlebell-seated-two-arm-overhead-press",
    fitNotesId: "",
  },
  {
    id: "seated-wide-angle-pose-sequence",
    fitNotesId: "",
  },
  {
    id: "seated-wide-grip-row",
    fitNotesId: "",
  },
  {
    id: "seated-hip-lateral-rotation",
    fitNotesId: "",
  },
  {
    id: "shoulder-adduction-stretch",
    fitNotesId: "",
  },
  {
    id: "shoulder-backbend-stretch",
    fitNotesId: "",
  },
  {
    id: "shoulder-extension-stretch",
    fitNotesId: "",
  },
  {
    id: "shoulder-grip-pull-up",
    fitNotesId: "",
  },
  {
    id: "shoulder-medial-rotation",
    fitNotesId: "",
  },
  {
    id: "shoulder-tap-push-up",
    fitNotesId: "",
  },
  {
    id: "shoulder-transverse-adduction-stretch",
    fitNotesId: "",
  },
  {
    id: "shoulder-transverse-extension",
    fitNotesId: "",
  },
  {
    id: "shrimp-squat",
    fitNotesId: "Shrimp Squat",
  },
  {
    id: "side-bridge",
    fitNotesId: "",
  },
  {
    id: "side-crunch",
    fitNotesId: "",
  },
  {
    id: "side-hip-abduction",
    fitNotesId: "",
  },
  {
    id: "side-leg-circle",
    fitNotesId: "",
  },
  {
    id: "side-leg-lift",
    fitNotesId: "",
  },
  {
    id: "side-lunge-stretch",
    fitNotesId: "",
  },
  {
    id: "side-lying-clam",
    fitNotesId: "",
  },
  {
    id: "side-lying-hip-abduction",
    fitNotesId: "",
  },
  {
    id: "side-lying-leg-raise",
    fitNotesId: "",
  },
  {
    id: "side-neck-stretch",
    fitNotesId: "",
  },
  {
    id: "side-plank",
    fitNotesId: "Side Plank",
  },
  {
    id: "side-push-neck-stretch",
    fitNotesId: "",
  },
  {
    id: "side-push-up",
    fitNotesId: "",
  },
  {
    id: "side-wrist-pull-stretch",
    fitNotesId: "",
  },
  {
    id: "sideway-lifts-vertical-turn",
    fitNotesId: "",
  },
  {
    id: "single-arm-band-cross-body-chest-press",
    fitNotesId: "",
  },
  {
    id: "single-arm-bench-press",
    fitNotesId: "",
  },
  {
    id: "single-arm-bent-over-cable-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "single-arm-cable-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "single-arm-cable-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "single-arm-cable-chest-fly",
    fitNotesId: "Single Arm Cable Chest Fly",
  },
  {
    id: "single-arm-cable-chest-press",
    fitNotesId: "",
  },
  {
    id: "single-arm-cable-front-raise",
    fitNotesId: "",
  },
  {
    id: "single-arm-cable-lat-pulldown",
    fitNotesId: "",
  },
  {
    id: "single-arm-cable-lateral-raise",
    fitNotesId: "",
  },
  {
    id: "single-arm-cable-overhead-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "single-arm-cable-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "single-arm-dumbbell-floor-press",
    fitNotesId: "",
  },
  {
    id: "single-arm-dumbbell-lying-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "single-arm-dumbbell-overhead-carry",
    fitNotesId: "",
  },
  {
    id: "single-arm-dumbbell-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "single-arm-dumbbell-snatch",
    fitNotesId: "",
  },
  {
    id: "single-arm-dumbbell-supinated-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "single-arm-dumbbell-wrist-curl",
    fitNotesId: "",
  },
  {
    id: "single-arm-floor-dumbbell-fly",
    fitNotesId: "",
  },
  {
    id: "single-arm-floor-rear-delt-raise",
    fitNotesId: "",
  },
  {
    id: "single-arm-hang",
    fitNotesId: "",
  },
  {
    id: "single-arm-kettlebell-clean-and-jerk",
    fitNotesId: "",
  },
  {
    id: "single-arm-kettlebell-jerk",
    fitNotesId: "",
  },
  {
    id: "single-arm-kettlebell-overhead-press-to-side",
    fitNotesId: "",
  },
  {
    id: "single-arm-kettlebell-overhead-press",
    fitNotesId: "",
  },
  {
    id: "single-arm-kettlebell-snatch",
    fitNotesId: "",
  },
  {
    id: "single-arm-kettlebell-swing",
    fitNotesId: "",
  },
  {
    id: "single-arm-lat-pulldown",
    fitNotesId: "",
  },
  {
    id: "single-arm-lateral-wide-pulldown",
    fitNotesId: "",
  },
  {
    id: "single-arm-low-dumbbell-fly",
    fitNotesId: "",
  },
  {
    id: "single-arm-low-row-machine",
    fitNotesId: "",
  },
  {
    id: "single-arm-pronated-dumbbell-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "single-arm-push-up",
    fitNotesId: "",
  },
  {
    id: "single-arm-reverse-dumbbell-curl",
    fitNotesId: "",
  },
  {
    id: "single-arm-reverse-grip-tricep-extension",
    fitNotesId: "",
  },
  {
    id: "single-arm-seated-neutral-wrist-curl",
    fitNotesId: "",
  },
  {
    id: "single-arm-side-barbell-deadlift",
    fitNotesId: "",
  },
  {
    id: "single-arm-triceps-pushdown",
    fitNotesId: "",
  },
  {
    id: "single-arm-twisting-cable-floor-row",
    fitNotesId: "",
  },
  {
    id: "single-arm-wall-push-up",
    fitNotesId: "",
  },
  {
    id: "single-arm-wide-grip-dumbbell-bench-press",
    fitNotesId: "",
  },
  {
    id: "single-arms-cable-twisted-overhead-press",
    fitNotesId: "",
  },
  {
    id: "single-dumbbell-front-raise",
    fitNotesId: "",
  },
  {
    id: "single-dumbbell-incline-close-grip-chest-press",
    fitNotesId: "",
  },
  {
    id: "single-lean-back-quadriceps-stretch",
    fitNotesId: "",
  },
  {
    id: "single-leg-bridge",
    fitNotesId: "",
  },
  {
    id: "single-leg-calf-foam-roll",
    fitNotesId: "",
  },
  {
    id: "single-leg-deadlift-with-knee-raise",
    fitNotesId: "",
  },
  {
    id: "single-leg-floor-dips",
    fitNotesId: "",
  },
  {
    id: "single-leg-glute-bridge-on-bench",
    fitNotesId: "",
  },
  {
    id: "single-leg-hip-thrust",
    fitNotesId: "",
  },
  {
    id: "single-leg-horizontal-leg-press",
    fitNotesId: "",
  },
  {
    id: "single-leg-low-box-squat",
    fitNotesId: "",
  },
  {
    id: "single-leg-lying-biceps-curl-with-towel",
    fitNotesId: "",
  },
  {
    id: "single-leg-over-knee-glute-bridge",
    fitNotesId: "",
  },
  {
    id: "single-leg-sliding-floor-bridge-curl-on-towel",
    fitNotesId: "",
  },
  {
    id: "single-leg-squat-with-support",
    fitNotesId: "",
  },
  {
    id: "single-leg-stand",
    fitNotesId: "",
  },
  {
    id: "single-leg-standing-calf-raise",
    fitNotesId: "",
  },
  {
    id: "single-leg-wall-squat-with-stability-ball",
    fitNotesId: "",
  },
  {
    id: "single-side-archer-push-up",
    fitNotesId: "",
  },
  {
    id: "single-straight-leg-stretch",
    fitNotesId: "",
  },
  {
    id: "sissy-squat",
    fitNotesId: "",
  },
  {
    id: "sit-up-twist",
    fitNotesId: "",
  },
  {
    id: "sit-up",
    fitNotesId: "",
  },
  {
    id: "sitting-bent-over-stretch",
    fitNotesId: "",
  },
  {
    id: "sitting-side-reach-stretch",
    fitNotesId: "",
  },
  {
    id: "sitting-sumo-mobility-stretch",
    fitNotesId: "",
  },
  {
    id: "sitting-wide-leg-abductor-stretch",
    fitNotesId: "",
  },
  {
    id: "skater-hop",
    fitNotesId: "",
  },
  {
    id: "ski-eliptical-machine",

    fitNotesId: "",
  },
  {
    id: "skierg-machine",

    fitNotesId: "",
  },
  {
    id: "leg-press-machine",
    fitNotesId: "Leg Press",
  },
  {
    id: "wide-stance-leg-press-machine",
    fitNotesId: "",
  },
  {
    id: "narrow-stance-leg-press-machine",
    fitNotesId: "",
  },
  {
    id: "single-leg-press-machine",
    fitNotesId: "",
  },
  {
    id: "sled-reverse-hack-squat",
    fitNotesId: "",
  },
  {
    id: "sled-wide-hack-squat",
    fitNotesId: "",
  },
  {
    id: "sliding leg curl on floor with towel",
    fitNotesId: "",
  },
  {
    id: "smith-decline-bench-press",
    fitNotesId: "",
  },
  {
    id: "smith-machine-back-shrug",
    fitNotesId: "",
  },
  {
    id: "smith-machine-behind-the-neck-press",
    fitNotesId: "",
  },
  {
    id: "smith-machine-bench-press",
    fitNotesId: "",
  },
  {
    id: "smith-machine-box-squat",
    fitNotesId: "",
  },
  {
    id: "smith-machine-bent-knee-good-morning",
    fitNotesId: "",
  },
  {
    id: "smith-machine-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "smith-machine-biceps-curl",
    fitNotesId: "",
  },
  {
    id: "smith-machine-bulgarian-squat",
    fitNotesId: "",
  },
  {
    id: "smith-machine-calf-raise",
    fitNotesId: "",
  },
  {
    id: "smith-machine-chair-squat",
    fitNotesId: "",
  },
  {
    id: "smith-machine-close-grip-bench-press",
    fitNotesId: "Smith Machine Close Grip Bench Press",
  },
  {
    id: "smith-machine-deadlift",
    fitNotesId: "",
  },
  {
    id: "smith-machine-front-squat",
    fitNotesId: "",
  },
  {
    id: "smith-machine-hex-press",
    fitNotesId: "",
  },
  {
    id: "smith-machine-hip-raise",
    fitNotesId: "",
  },
  {
    id: "smith-machine-hip-thrust",
    fitNotesId: "",
  },
  {
    id: "smith-machine-incline-bench-press",
    fitNotesId: "",
  },
  {
    id: "smith-machine-kneeling-rear-kick",
    fitNotesId: "",
  },
  {
    id: "smith-machine-leg-press",
    fitNotesId: "",
  },
  {
    id: "smith-machine-narrow-stance-row",
    fitNotesId: "",
  },
  {
    id: "smith-machine-rear-delt-row",
    fitNotesId: "",
  },
  {
    id: "smith-machine-seated-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "smith-machine-overhead-press",
    fitNotesId: "Smith Machine Overhead Press",
  },
  {
    id: "smith-machine-shrug",
    fitNotesId: "",
  },
  {
    id: "smith-machine-single-arm-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "smith-machine-single-leg-calf-raise",
    fitNotesId: "",
  },
  {
    id: "smith-machine-split-squat",
    fitNotesId: "",
  },
  {
    id: "smith-machine-squat",
    fitNotesId: "",
  },
  {
    id: "smith-machine-stiff-leg-deadlift",
    fitNotesId: "",
  },
  {
    id: "smith-machine-sumo-squat",
    fitNotesId: "",
  },
  {
    id: "smith-machine-upright-row",
    fitNotesId: "",
  },
  {
    id: "smith-machine-wide-grip-seated-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "smith-reverse-calf-raise",
    fitNotesId: "",
  },
  {
    id: "smith-sprint-lounge",
    fitNotesId: "",
  },
  {
    id: "snatch-deadlift",
    fitNotesId: "",
  },
  {
    id: "snatch-pull",
    fitNotesId: "",
  },
  {
    id: "spellcaster",
    fitNotesId: "",
  },
  {
    id: "spiderman-push-up",
    fitNotesId: "",
  },
  {
    id: "spine-backbend-stretch",
    fitNotesId: "",
  },
  {
    id: "spine-stretch-forward",
    fitNotesId: "",
  },
  {
    id: "spine-stretch",
    fitNotesId: "",
  },
  {
    id: "split-jump-to-box",
    fitNotesId: "",
  },
  {
    id: "split-jump",
    fitNotesId: "",
  },
  {
    id: "sprinter-lunge",
    fitNotesId: "",
  },
  {
    id: "strict-biceps-curl",
    fitNotesId: "Strict Curl",
  },
  {
    id: "squat-jump",
    fitNotesId: "",
  },
  {
    id: "squat-machine",
    fitNotesId: "",
  },
  {
    id: "squat-tuck-jump",
    fitNotesId: "",
  },
  {
    id: "squat",
    fitNotesId: "",
  },
  {
    id: "squatting-cable-curl",
    fitNotesId: "",
  },
  {
    id: "stability-ball-back-extension-with-hands-behind-head",
    fitNotesId: "",
  },
  {
    id: "stability-ball-barbell-seated-twist",
    fitNotesId: "",
  },
  {
    id: "stability-ball-bent-knee-lying-twist",
    fitNotesId: "",
  },
  {
    id: "stability-ball-cable-chest-fly",
    fitNotesId: "",
  },
  {
    id: "stability-ball-chest-fly",
    fitNotesId: "",
  },
  {
    id: "stability-ball-crunch",
    fitNotesId: "",
  },
  {
    id: "stability-ball-dumbbell-fly",
    fitNotesId: "",
  },
  {
    id: "stability-ball-dumbbell-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "stability-ball-dumbbell-pullover-hip-extension",
    fitNotesId: "",
  },
  {
    id: "stability-ball-dumbbell-pullover",
    fitNotesId: "",
  },
  {
    id: "stability-ball-hip-thrust",
    fitNotesId: "",
  },
  {
    id: "stability-ball-incline-dumbbell-fly",
    fitNotesId: "",
  },
  {
    id: "stability-ball-lat-stretch",
    fitNotesId: "",
  },
  {
    id: "stability-ball-leg-curl",
    fitNotesId: "",
  },
  {
    id: "stability-ball-lying-oblique-twist",
    fitNotesId: "",
  },
  {
    id: "stability-ball-lying-side-lat-stretch",
    fitNotesId: "",
  },
  {
    id: "stability-ball-pull-in",
    fitNotesId: "",
  },
  {
    id: "stability-ball-rollout-on-knees",
    fitNotesId: "",
  },
  {
    id: "standing-alternate-arm-circles",
    fitNotesId: "",
  },
  {
    id: "standing-arms-flinging",
    fitNotesId: "",
  },
  {
    id: "standing-band-hip-flexion",
    fitNotesId: "",
  },
  {
    id: "standing-barbell-calf-raise",
    fitNotesId: "",
  },
  {
    id: "standing-barbell-concentration-curl",
    fitNotesId: "",
  },
  {
    id: "standing-barbell-overhead-triceps-extension",
    fitNotesId: "Overhead Barbell Extension",
  },
  {
    id: "standing-behind-neck-press",
    fitNotesId: "Behind The Neck Barbell Press",
  },
  {
    id: "standing-cable-chest-press",
    fitNotesId: "",
  },
  {
    id: "standing-cable-crunch",
    fitNotesId: "Standing Cable Crunch",
  },
  {
    id: "standing-cable-fly",
    fitNotesId: "",
  },
  {
    id: "standing-cable-front-raise",
    fitNotesId: "",
  },
  {
    id: "standing-cable-hip-extension",
    fitNotesId: "",
  },
  {
    id: "standing-cable-lift",
    fitNotesId: "",
  },
  {
    id: "standing-cable-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "standing-calf-raise",
    fitNotesId: "",
  },
  {
    id: "standing-concentration-curl",
    fitNotesId: "",
  },
  {
    id: "standing-dumbbell-alternate-shoulder-press",
    fitNotesId: "",
  },
  {
    id: "standing-dumbbell-preacher-curl",
    fitNotesId: "",
  },
  {
    id: "standing-dumbbell-shoulder-press",
    fitNotesId: "Standing Shoulder Press",
  },
  {
    id: "standing-overhead-dumbbell-triceps-extension",
    fitNotesId: "Dumbbell Overhead Triceps Extension",
  },
  {
    id: "standing-ez-bar-french-press",
    fitNotesId: "",
  },

  {
    id: "standing-gastrocnemius-calf-stretch",
    fitNotesId: "",
  },
  {
    id: "band-standing-hamstring-and-calf-stretch",
    fitNotesId: "",
  },
  {
    id: "standing-hip-abduction",
    fitNotesId: "",
  },
  {
    id: "standing-hip-circle",
    fitNotesId: "",
  },
  {
    id: "standing-hip-extension",
    fitNotesId: "",
  },
  {
    id: "standing-lat-pushdown",
    fitNotesId: "",
  },
  {
    id: "standing-lateral-side-stretch",
    fitNotesId: "",
  },
  {
    id: "standing-lateral-stretch",
    fitNotesId: "",
  },
  {
    id: "standing-one-arm-chest-stretch",
    fitNotesId: "",
  },
  {
    id: "standing-palms-in-dumbbell-press",
    fitNotesId: "",
  },
  {
    id: "standing-pelvic-tilt",
    fitNotesId: "",
  },
  {
    id: "standing-plate-press",
    fitNotesId: "",
  },
  {
    id: "standing-plate-twist",
    fitNotesId: "",
  },
  {
    id: "standing-quadriceps-stretch",
    fitNotesId: "",
  },
  {
    id: "standing-reach-down-stretch",
    fitNotesId: "",
  },
  {
    id: "standing-reach-up-back-rotation-stretch",
    fitNotesId: "",
  },
  {
    id: "standing-rear-kick-machine",
    fitNotesId: "",
  },
  {
    id: "standing-shoulder-external-rotation",
    fitNotesId: "",
  },
  {
    id: "standing-side-bend",
    fitNotesId: "",
  },
  {
    id: "standing-single-arm-dumbbell-triceps-extension",
    fitNotesId: "",
  },
  {
    id: "standing-single-arm-incline-dumbell-curl",
    fitNotesId: "",
  },
  {
    id: "standing-single-arm-twist-row",
    fitNotesId: "",
  },
  {
    id: "standing-single-leg-hip-abduction-machine",
    fitNotesId: "",
  },
  {
    id: "standing-upright-shoulder-stretch",
    fitNotesId: "",
  },
  {
    id: "standing-wall-calf-stretch",
    fitNotesId: "",
  },
  {
    id: "standing-weighted-neck-harness-extension",
    fitNotesId: "",
  },
  {
    id: "starfish-crunch",
    fitNotesId: "",
  },
  {
    id: "static-lunge",
    fitNotesId: "",
  },
  {
    id: "stationary-bike",
    fitNotesId: "Stationary Bike",
  },
  {
    id: "step-up",
    fitNotesId: "",
  },
  {
    id: "stepmill-walking",
    fitNotesId: "",
  },
  {
    id: "stepper-machine",
    fitNotesId: "",
  },
  {
    id: "stiff-leg-cable-deadlift",
    fitNotesId: "",
  },
  {
    id: "straight-arm-pulldown",
    fitNotesId: "Straight-Arm Cable Pushdown",
  },
  {
    id: "straight-arm-pushdown",
    fitNotesId: "",
  },
  {
    id: "straight-bar-seated-row",
    fitNotesId: "",
  },
  {
    id: "sumo-deadlift-high-pull",

    fitNotesId: "",
  },
  {
    id: "sumo-deadlift",
    fitNotesId: "",
  },
  {
    id: "sumo-dumbbell-pull-through",
    fitNotesId: "",
  },
  {
    id: "superman-push-up",

    fitNotesId: "",
  },
  {
    id: "superman-raise",
    fitNotesId: "",
  },
  {
    id: "superman-row-with-towell",
    fitNotesId: "",
  },
  {
    id: "supinated-grip-seated-cable-row",
    fitNotesId: "",
  },
  {
    id: "supine-medicine-ball-chest-throw",
    fitNotesId: "",
  },
  {
    id: "TRX-fallout",
    fitNotesId: "",
  },
  {
    id: "ring-push-up",
    fitNotesId: "",
  },
  {
    id: "ring-row",
    fitNotesId: "Inverted Horizontal Ring Rows",
  },
  {
    id: "TRX-split-squat",
    fitNotesId: "",
  },
  {
    id: "svend-press",
    fitNotesId: "",
  },
  {
    id: "swimming",
    fitNotesId: "Swimming",
  },
  {
    id: "swimmer-kicks",
    fitNotesId: "",
  },
  {
    id: "switch-lunge",
    fitNotesId: "",
  },
  {
    id: "t-bar-row",
    fitNotesId: "T-Bar Row",
  },
  {
    id: "tensor-fasciae-latae-foam-roll",
    fitNotesId: "",
  },
  {
    id: "thoracic-bridge",
    fitNotesId: "",
  },
  {
    id: "tip-toe-squat",
    fitNotesId: "",
  },
  {
    id: "torso-rotation-machine",
    fitNotesId: "",
  },
  {
    id: "towel-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "trap-bar-bent-over-row",
    fitNotesId: "",
  },
  {
    id: "trap-bar-deadlift",
    fitNotesId: "Trap Bar Deadlift",
  },
  {
    id: "trap-bar-farmers-walk",
    fitNotesId: "",
  },
  {
    id: "trap-bar-standing-shrug",
    fitNotesId: "",
  },
  {
    id: "triceps-dips-on-chair",
    fitNotesId: "",
  },
  {
    id: "triceps-dips",
    fitNotesId: "Parallel Bar Triceps Dip",
  },
  {
    id: "triceps-extension-machine",
    fitNotesId: "",
  },
  {
    id: "triceps-pushdown",
    fitNotesId: "Bar Push Down",
  },
  {
    id: "rope-triceps-pushdown",
    fitNotesId: "Rope Push Down",
  },
  {
    id: "trx-inverted-row",
    fitNotesId: "",
  },
  {
    id: "trx-supine-crunch",
    fitNotesId: "",
  },
  {
    id: "tuck-crunch",
    fitNotesId: "",
  },
  {
    id: "twist-superman",
    fitNotesId: "",
  },
  {
    id: "twisting-crunch",
    fitNotesId: "",
  },
  {
    id: "two-arm-seated-dumbbell-extension",
    fitNotesId: "",
  },
  {
    id: "underhand-grip-inverted-row",
    fitNotesId: "",
  },
  {
    id: "upper-back-foam-roll",
    fitNotesId: "",
  },
  {
    id: "upright-row",
    fitNotesId: "",
  },
  {
    id: "v-sit-up",
    fitNotesId: "",
  },
  {
    id: "vbar-lat-pulldown",
    fitNotesId: "",
  },
  {
    id: "vbar-seated-cable-row",
    fitNotesId: "Seated Cable Row",
  },
  {
    id: "vbar-triceps-pushdown",
    fitNotesId: "V-Bar Push Down",
  },
  {
    id: "vibration-plate-lunge",
    fitNotesId: "",
  },
  {
    id: "vibration-plate-plank",
    fitNotesId: "",
  },
  {
    id: "vibration-plate-standing",
    fitNotesId: "",
  },
  {
    id: "walk-wave-machine",
    fitNotesId: "",
  },
  {
    id: "walking-lunge",
    fitNotesId: "",
  },
  {
    id: "walking-on-incline-treadmill",
    fitNotesId: "",
  },
  {
    id: "walking-on-treadmill",
    fitNotesId: "",
  },
  {
    id: "walking",
    fitNotesId: "Walking",
  },
  {
    id: "wall-elbow-flexor-stretch",
    fitNotesId: "",
  },
  {
    id: "wall-push-up",
    fitNotesId: "",
  },
  {
    id: "wall-sit",
    fitNotesId: "",
  },
  {
    id: "wall-supported-bodyweight-standing-overhead-press",
    fitNotesId: "",
  },
  {
    id: "weighted-chin-up",
    fitNotesId: "",
  },
  {
    id: "weighted-counterbalance-squat",
    fitNotesId: "",
  },
  {
    id: "weighted-crunch",
    fitNotesId: "",
  },
  {
    id: "weighted-decline-sit-up",
    fitNotesId: "",
  },
  {
    id: "weighted-front-plank",
    fitNotesId: "",
  },
  {
    id: "weighted-hanging-leg-hip-raise",
    fitNotesId: "",
  },
  {
    id: "weighted-round-arm",
    fitNotesId: "",
  },
  {
    id: "weighted-side-bend-with-stability-ball",
    fitNotesId: "",
  },
  {
    id: "weighted-standing-plate-curl",
    fitNotesId: "",
  },
  {
    id: "weighted-stretch-lunge",
    fitNotesId: "",
  },
  {
    id: "weighted-three-bench-dips",
    fitNotesId: "",
  },
  {
    id: "weighted-twisting-crunch",
    fitNotesId: "",
  },
  {
    id: "wide-grip-behind-neck-pulldown",
    fitNotesId: "",
  },
  {
    id: "wide-grip-chest-dips",
    fitNotesId: "",
  },
  {
    id: "wide-grip-lat-pulldown",
    fitNotesId: "Wide Grip Pull Down",
  },
  {
    id: "wide-grip-overhead-press",
    fitNotesId: "",
  },
  {
    id: "wide-grip-pull-up",
    fitNotesId: "",
  },
  {
    id: "wide-grip-underhand-lat-pulldown",
    fitNotesId: "",
  },
  {
    id: "wide-hand-push-up",
    fitNotesId: "",
  },
  {
    id: "windshield-wipers",
    fitNotesId: "",
  },
  {
    id: "wrist-adduction-stretch",
    fitNotesId: "",
  },
  {
    id: "wrist-articulations-stretch",
    fitNotesId: "",
  },
  {
    id: "wrist-circle",
    fitNotesId: "",
  },
  {
    id: "wrist-extensor-stretch",
    fitNotesId: "",
  },
  {
    id: "wrist-flexion-stretch",
    fitNotesId: "",
  },
  {
    id: "wrist-flexor-stretch",
    fitNotesId: "",
  },
  {
    id: "wrist-roller",
    fitNotesId: "",
  },
  {
    id: "wrist-ulnar-deviator-flexor-stretch",
    fitNotesId: "",
  },
  {
    id: "zercher-squat",
    fitNotesId: "",
  },
  {
    id: "zottman-biceps-curl",
    fitNotesId: "",
  },
];
